import Image from "next/image";
import { Box, HStack, Stack } from "@chakra-ui/react";
import TickImage from "public/shared/check-box.png";
import { Text } from "@/elements";

export type ListWithLabelProps = {
  points: { label?: string; text: string }[];
  separator?: string;
  textColor?: string;
  spacing?: number;
};

const ListWithLabel = (props: ListWithLabelProps) => {
  const { points, separator = ":", textColor = "text.100", spacing = 1 } = props;
  const textVariant = "body2";
  return (
    <Box>
      <Stack gap={spacing}>
        {points.map((point, index) => {
          const { text, label } = point;
          return (
            <HStack key={index} color={textColor} align={"start"}>
              <Image
                alt="Point"
                src={TickImage}
                width={20}
                height={20}
                style={{ paddingTop: "4px" }}
              />{" "}
              <Box>
                {label && (
                  <Text as="span" fontWeight={700} variant={textVariant}>
                    {`${label} ${separator} `}
                  </Text>
                )}
                <Text as="span" variant={textVariant}>
                  {text}
                </Text>
              </Box>
            </HStack>
          );
        })}
      </Stack>
    </Box>
  );
};

export default ListWithLabel;
